/* L&P David wallet gift (2026-09-25, Adam). The David 1+1 is retired; every order with a
   David watch gets the L&P card-holder wallet (variant 46231533945023) free, value ₪400.
   The ₪0 comes from the automatic discount "מתנה בשווי ₪400" (buys davidwatches, gets the
   wallet 100%, once per order). This file only keeps the cart in the right shape:

     David watch in the cart, no wallet  -> add ONE wallet line, tagged _lp_gift=david-wallet
     more than one tagged wallet / qty>1 -> clamp to one line, qty 1 (the discount frees ONE;
                                            a second one would be charged ₪399.90)
     no David watch left                 -> remove the tagged wallet
     tagged wallet NOT free              -> remove it (never charge for the gift). Happens when
                                            the discount cannot combine with another product
                                            discount in the same cart. Not re-added until the
                                            rest of the cart changes.
   A wallet the customer bought on its own (no tag) is never touched, and when one is present
   no tagged wallet is added (the discount would free that one instead).
   Runs on load and after every /cart/add|change|update|clear the page makes. Every write is
   idempotent, so a double trigger converges instead of stacking. */
(function () {
  if (window.__lpDavidGift) return;
  window.__lpDavidGift = true;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('lp-david-gift-cfg').textContent || '{}'); } catch (e) { return; }
  var WALLET = Number(cfg.wallet);
  var DAVID = {};
  (cfg.david || []).forEach(function (id) { DAVID[Number(id)] = true; });
  if (!WALLET || !Object.keys(DAVID).length) return;
  var TAG = '_lp_gift', TAG_V = 'david-wallet', BLOCK_KEY = 'lp_david_gift_block';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ofetch = window.fetch.bind(window);
  var running = false, again = false, timer = null;

  function isTagged(it) { return it.variant_id === WALLET && it.properties && it.properties[TAG] === TAG_V; }
  function post(path, body) {
    return ofetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }
  function getCart() { return ofetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function signature(cart) {
    return cart.items.filter(function (it) { return !isTagged(it); })
      .map(function (it) { return it.variant_id + 'x' + it.quantity; }).sort().join(',');
  }
  function getBlock() { try { return sessionStorage.getItem(BLOCK_KEY) || ''; } catch (e) { return ''; } }
  function setBlock(v) { try { if (v) sessionStorage.setItem(BLOCK_KEY, v); else sessionStorage.removeItem(BLOCK_KEY); } catch (e) {} }

  /* one pass: returns true when it wrote something */
  function pass(cart) {
    var hasDavid = cart.items.some(function (it) { return DAVID[it.product_id] && it.final_line_price > 0; });
    var tagged = cart.items.filter(isTagged);
    var ownWallet = cart.items.some(function (it) { return it.variant_id === WALLET && !isTagged(it); });
    var sig = signature(cart);

    if (!hasDavid || ownWallet) {
      if (!tagged.length) return Promise.resolve(false);
      return post('cart/change.js', { id: tagged[0].key, quantity: 0 }).then(function () { return true; });
    }
    if (tagged.length > 1) {
      return post('cart/change.js', { id: tagged[tagged.length - 1].key, quantity: 0 }).then(function () { return true; });
    }
    if (tagged.length === 1) {
      var t = tagged[0];
      if (t.quantity > 1) return post('cart/change.js', { id: t.key, quantity: 1 }).then(function () { return true; });
      if (t.final_line_price > 0) {
        setBlock(sig);
        return post('cart/change.js', { id: t.key, quantity: 0 }).then(function () { return true; });
      }
      setBlock('');
      return Promise.resolve(false);
    }
    if (getBlock() === sig) return Promise.resolve(false);
    setBlock('');
    var props = {}; props[TAG] = TAG_V;
    return post('cart/add.js', { items: [{ id: WALLET, quantity: 1, properties: props }] }).then(function () { return true; });
  }

  function refreshUi() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    ofetch(root + '?sections=cart-drawer,cart-icon-bubble', { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && typeof drawer.renderContents === 'function' && sections['cart-drawer']) {
          /* Shrine's renderContents(state, dontOpen): keep a closed drawer closed */
          var wasOpen = drawer.classList.contains('active');
          try { drawer.renderContents({ sections: sections, id: null }, !wasOpen); } catch (e) {}
        } else if (sections['cart-icon-bubble']) {
          var b = document.getElementById('cart-icon-bubble');
          if (b) {
            var d = document.createElement('div'); d.innerHTML = sections['cart-icon-bubble'];
            var n = d.querySelector('#cart-icon-bubble') || d.firstElementChild;
            if (n) b.innerHTML = n.innerHTML;
          }
        }
      }).catch(function () {});
  }

  function sync() {
    if (running) { again = true; return; }
    running = true;
    var wrote = false, rounds = 0;
    (function loop() {
      getCart().then(function (cart) { return pass(cart); }).then(function (w) {
        wrote = wrote || w;
        rounds += 1;
        if (w && rounds < 4) return loop();
        running = false;
        if (wrote) refreshUi();
        if (again) { again = false; schedule(); }
      }).catch(function () { running = false; });
    })();
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 250); }
  function isCartWrite(url) { return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || '')); }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = ofetch(input, init);
    if (isCartWrite(url)) p.then(function () { schedule(); }, function () {});
    return p;
  };
  var oopen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', schedule);
    return oopen.apply(this, arguments);
  };

  /* on load, only when the server-rendered cart holds a David watch or a wallet: no extra
     /cart.js request on the other pages */
  if (cfg.need) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
    else schedule();
  }
})();
